// extracted by mini-css-extract-plugin
module.exports = {"container":"WarningNote_container__2Q6Mu","content":"WarningNote_content__207e2","leftContent":"WarningNote_leftContent__3H38l","button":"WarningNote_button__2Hw95"};